import React from 'react';
import { Icon, IconProps } from '../../icons/Icon';

import './EmptyState.css';

export interface EmptyStateProps {
  /** Icon name from Lucide icons */
  icon?: IconProps['name'];
  /** Title text */
  title: string;
  /** Description text */
  description?: string;
  /** Optional action (typically a Button component) */
  action?: React.ReactNode;
  /** Additional CSS class */
  className?: string;
}

export const EmptyState = React.memo(function EmptyState({
  icon,
  title,
  description,
  action,
  className = '',
}: EmptyStateProps) {
  return (
    <div className={`empty-state ${className}`.trim()}>
      {icon && (
        <div className="empty-state__icon">
          <Icon name={icon} size={32} />
        </div>
      )}
      <h3 className="empty-state__title">{title}</h3>
      {description && <p className="empty-state__description">{description}</p>}
      {action && <div className="empty-state__action">{action}</div>}
    </div>
  );
});
